import {
	defineStore
} from 'pinia'
import {
	getAppMemberInfo,
	getApplication,
	refreshToken
} from '@/service/user.js'

const TOKEN_EXPIRES_KEY = "token_expires_at";
let refreshTimer = null;

const REFRESH_BEFORE = 120 * 1000;
const MIN_REFRESH_DELAY = 60 * 1000;

export const useUserStore = defineStore('user', {
	state: () => ({
		info: null,
		loyalty: null,
		member: null,
		accessToken: '',
		refreshToken: ''
	}),
	actions: {
		async getInfo() {
			const res = await getAppMemberInfo()
			this.info = res.result
		},
		async getApplication() {
			const res = await getApplication()
			this.loyalty = res.data?.loyalty
			this.member = res.data?.member
		},
		async logout() {
			uni.removeStorageSync("token")
			uni.removeStorageSync("rt")
			uni.removeStorageSync(TOKEN_EXPIRES_KEY)
			if (refreshTimer) clearTimeout(refreshTimer);
			this.info = null;
		},
		startRefreshTimer(stamp) {
			uni.setStorageSync(TOKEN_EXPIRES_KEY, stamp);
			if (refreshTimer) {
				clearTimeout(refreshTimer);
				refreshTimer = null;
			}

			let delay = stamp - Date.now() - REFRESH_BEFORE;

			if (delay < MIN_REFRESH_DELAY) {
				delay = MIN_REFRESH_DELAY;
			}
			refreshTimer = setTimeout(async () => {
				await this.refreshAccessToken();
			}, delay);
		},
		getRsStamp(expiresIn) {
			const ss = expiresIn || 3000;
			const stamp = Date.now() + ss * 1000;
			return stamp
		},
		async refreshAccessToken() {
			try {
				const rt = uni.getStorageSync('rt');
				const res = await refreshToken({
					refreshToken: rt
				})
				if (!res.success) {
					if (res.data?.errors?.[0]?.code === 1007) throw new Error("Token expired");
					return;
				};
				const data = res.data;
				uni.setStorageSync('rt', data.refreshToken);
				uni.setStorageSync('token', data.accessToken);
				const stamp = this.getRsStamp(data.expiresIn)
				this.startRefreshTimer(stamp)
				return res;
			} catch (error) {
				console.log(error)
				this.logout()
				// #ifdef MP-WEIXIN
				uni.navigateTo({
					url: '/pages/login/index'
				})
				// #endif

				// #ifndef MP-WEIXIN
				uni.navigateTo({
					url: '/pages/mobileLogin/index'
				})
				// #endif

				return error;
			}
		},
		reStartRefresh() {
			const expiresAt = uni.getStorageSync(TOKEN_EXPIRES_KEY);
			const rt = uni.getStorageSync('rt');
			const token = uni.getStorageSync('token');
			if (!expiresAt || !rt || !token) return
			const remaining = expiresAt - Date.now()
			if (remaining <= REFRESH_BEFORE) {
				this.refreshAccessToken()
				return
			}
			this.startRefreshTimer(expiresAt)
		}
	},
})